import type { IRequestGetOne } from '@frontend/components/interfaces/requestGetOne';
import { ServiceCode, ServiceType } from '@common/enums';
import { getSelectedLanguage } from '@frontend/translate';

export function getStartProcedureOrConsultButtonText(request: IRequestGetOne) {
    const translate = getSelectedLanguage();

    if ([ServiceCode.DermaSnelC, ServiceCode.DermaSnelCsc].includes(request.service.code)) {
        return translate.request.action_evaluateConsult;
    }

    if (request.serviceType === ServiceType.consultation) {
        return translate.request.action_addConsultReport;
    }

    return translate.request.action_addProcedure;
}
